import { FloatingPortal } from '@floating-ui/react';
import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';

import ToastsContainer from './ToastsContainer';

function EnableToasts() {
    return (
        <>
            <Outlet />
            <FloatingPortal>
                <ToastsContainer />
            </FloatingPortal>
        </>
    );
}

export default memo(EnableToasts);
